var standalone = window.navigator.standalone,
  userAgent = window.navigator.userAgent.toLowerCase(),
  safari = /safari/.test(userAgent),
  ios = /iphone|ipod|ipad/.test(userAgent);

export const whatBrowser = () => {
  if (ios) {
    if (!standalone && safari) {
      console.log("Safari");
      return "Safari";
    } else if (!standalone && !safari) {
      console.log("iOS webview");
      return "IOS webview";
    }
  } else {
    if (userAgent.includes("wv")) {
      console.log("Android webview");
      return "Android webview";
    } else {
      console.log("Chrome");
      return "Chrome";
    }
  }
};
